export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0a0d14] text-white pt-16 pb-8"
    >
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 pb-12 border-b border-white/15">
          <h2 className="font-display font-black uppercase tracking-tighter text-5xl md:text-7xl leading-[0.85]">
            100 Idee
            <br />
            <span className="text-[#d9381e]">per Verona</span>
          </h2>
          <p className="max-w-xs text-white/60 font-medium leading-relaxed">
            Un programma concreto per la nostra città. Insieme, punto per punto.
          </p>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono-num uppercase text-[11px] tracking-widest text-white/40">
          <span>© {new Date().getFullYear()} — Elezioni Comunali di Verona</span>
          <div className="flex items-center gap-5">
            <span>Contenuti dimostrativi</span>
            <a
              href="/login"
              data-testid="footer-admin-link"
              className="hover:text-[#d9381e] transition-colors"
            >
              Area riservata
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
